<template>
  <el-card class="new-site-unit">
    <template slot="header">
      <el-steps :active="active" align-center>
        <el-step title="Type">
        </el-step>
        <el-step title="Details">
        </el-step>
        <el-step title="Images">
        </el-step>
        <el-step title="Tags">
        </el-step>
        <el-step title="Confirm Unit">
        </el-step>
      </el-steps>
    </template>
    <el-card shadow="never" v-if="active === 0">
      <div slot="header">
        <h4>
          Unit Type
        </h4>
      </div>
      <el-form :model="typeForm" ref="type" label-width="100px">
          <el-form-item label="Unit Type"
            prop="type"
          >
            <el-radio-group v-model="typeForm.type" @change="resetComputedSizeAndTier">
              <el-radio label="Warehouse">Warehouse</el-radio>
              <el-radio label="Office">Office</el-radio>
              <el-radio label="Parking">Parking</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never" v-if="active === 1">
      <div slot="header">
        <h4>
          Unit Details
        </h4>
      </div>
      <el-form :model="form" :rules="rules" ref="details" label-width="120px">
        <el-form-item label="Sides"
            prop="sides"
          >
            <el-input disabled v-model.number="form.sides" required clearable size="small"/>
          </el-form-item>
        <el-form-item label="Length in feet"
            prop="length"
            :rules="[
            { required: true, message: 'Please input length in feets', trigger: 'blur' },
            { type: 'number', message: 'Please input correct length between 6 - 150',
              trigger: ['blur', 'change'], min: 6, max: 150 }
            ]"
          >
            <el-input v-model.number="form.length" required clearable size="small" :disabled="typeForm.type === 'Parking'" />
          </el-form-item>
        <el-form-item label="Width in feet"
            prop="width"
            :rules="[
            { required: true, message: 'Please input width in feets', trigger: 'blur' },
            { type: 'number', message: 'Please input correct width between 6 - 150',
              trigger: ['blur', 'change'], min: 6, max: 150 },
            ]"
          >
          <el-input v-model.number="form.width" required clearable size="small" :disabled="typeForm.type === 'Parking'"/>
        </el-form-item>
        <el-form-item
          label="Size in feet"
          prop="computedSize"
          :rules="[
            { required: true, message: 'Please enter size of the unit in sft', trigger: 'blur' },
            { type: 'number', message:  typeForm.type === 'Office' ?  'Please input correct width between 10 - 669' : 'Please input correct width between 10 - 10,000',
              trigger: ['blur', 'change'], min: 10, max: 10000 },
            ]"
        >
          <el-input
            v-model.number="form.computedSize"
            required
            :disabled="typeForm.type === 'Parking' || (unit && unit._id)"
            clearable
            size="small"
            @input="setSizeMatrix"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Tier Quality"
          prop="tierQuality"
          :rules="[
            { required: true, message: 'Please select tier quality of the unit', trigger: 'blur' },
            ]"
        >
          <el-select
            size="small"
            v-model="form.tierQuality"
            placeholder="Tier Quality"
          >
            <el-option
              :key="option.value"
              v-for="option in tierQualityBasedOnType"
              :label="option.label" :value="option.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Size Tier"
            prop="size"
            :rules="[
            {
              required: typeForm.type !== 'Parking',
              message: 'Please enter Size to compute size matrix.', trigger: 'blur'
            },
          ]"
          >
          <el-select
            size="small"
            v-model="form.size"
            placeholder="Size Matrix"
            disabled
          >
            <el-option
              :label="item.label"
              :value="item.value"
              :key="item.label"
              v-for="item of sizeMatrix"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Height in feet"
            prop="height"
            :rules="[
            { required: true, message: 'Please input height in feets', trigger: 'blur' },
            { type: 'number', message: 'Please input correct height between 7 - 12',
              trigger: ['blur', 'change'], min: 7, max: 12 },
            ]"
          >
            <el-input v-model.number="form.height" required clearable size="small" :disabled="typeForm.type === 'Parking'"/>
          </el-form-item>
        <el-form-item label="Name"
            prop="name"
            :rules="[
            { required: true, message: 'Please input name', trigger: 'blur' },
            { type: 'string', message: 'Please input correct name',
              trigger: ['blur', 'change']},
            ]"
          >
            <el-input v-model="form.name" required clearable size="small"/>
          </el-form-item>
        <el-form-item label="Description"
            prop="description"
            :rules="[
            { type: 'string', message: 'Please input correct description',
              trigger: ['blur', 'change']},
            ]"
          >
            <el-input type="textarea" v-model="form.description" clearable size="small"/>
          </el-form-item>
        </el-form>
    </el-card>
    <!-- Step 4 -->
    <div v-else-if="active === 2">
        <Uploader
          listType="picture"
          @upload-completed="addImageToUnit"
          @remove-upload="removeImage"
          :upload-prefix="`location/${facility}/`"
        />
        <template>
          <div v-if="images && images.length > 0">
           <el-card class="upload-card" shadow="never">
             <ol v-if="images && images.length > 0">
               <li v-for="item in images" :key="item._id">{{ item.url }}</li>
             </ol>
           </el-card>
         </div>
         <div v-else class="upload-card">
         </div>
        </template>
    </div>
    <!-- Step 5 -->
    <div v-else-if="active === 3">
      <!-- <el-input @change="addTag" v-model="tagInput" suffix-icon="el-icon-circle-plus" placeholder="Press enter to add a tag!" /> -->
      <el-select v-model="selectedTags" @change="prepareTags" multiple>
        <el-option v-for="tag of tagsBasedOnType" :key="tag" :label="tag" :value="tag">
        </el-option>
      </el-select>
      <div class="tags">
        <el-tag class="tag" :key="tag.value" v-for="tag in tags">
          {{ tag.value }}
        </el-tag>
      </div>
    </div>
    <!-- Step 6 -->
    <div v-else-if="active === 4">
      <v-stage
        ref="stage"
      :config="configKonva"
      >
        <v-layer ref="number-layer">
          <v-group ref="group">
            <v-rect
              :config="{
                x: configKonva.width / 1.5,
                y: 20,
                width: form.width,
                height: form.length,
                fill: 'blue',
                shadowColor: 'black',
                shadowBlur: 10,
                shadowOpacity: 0.6,
                offset: 30
              }"
            >
            </v-rect>
            <v-text
              :config="{
                x: configKonva.width / 1.5,
                y: 40,
                text: form.name,
                fontSize: 3,
                fill: 'red',
                shadowColor: 'black',
                shadowBlur: 10,
                shadowOpacity: 0.6,
                scale: 100,
                offset: 30
              }"
            >
              {{ form.name }}
            </v-text>
          </v-group>
        </v-layer>
      </v-stage>
    </div>
    <div style="margin-top: 12px">
      <el-button v-if="showBackButton" v-show="active !== 0" type="warning" plain @click="() => active -= 1">Back</el-button>
      <el-button  v-show="active !== 4" @click="next">Next step</el-button>
      <el-button v-if="!unit && active === 4" @click="addUnit">Create</el-button>
      <el-button v-else-if="unit && active === 4" @click="addUnit">Confirm Changes</el-button>
    </div>
  </el-card>
</template>

<script>
import Uploader from './Uploader.vue';
import { setMatrixValueBasedOnTheSize, matrix, officeMatrix } from '../utils/sizeMatrix';
import unitTags, { officeTags, parkingTags } from '../utils/unitTags';

export default {
  name: 'SiteUnitType',
  components: { Uploader },
  props: {
    unit: { type: Object, default: null },
  },
  computed: {
    facility() {
      return this.$root.state.facility;
    },
    showBackButton() {
      // Don't allow changing unit type for existing units
      if (this.unit && this.unit._id && this.active === 1) { return false; }
      return true;
    },
    sizeMatrix() {
      return this.typeForm.type === 'Warehouse' ? matrix : officeMatrix;
    },
    tierQualityBasedOnType() {
      if (this.typeForm.type === 'Warehouse') {
        return [
          { label: 'A+',
            value: 'AA' },
          { label: 'A',
            value: 'A' },
          { label: 'B',
            value: 'B' },
          { label: 'C',
            value: 'C' },
          { label: 'D',
            value: 'D' },
          { label: 'S',
            value: 'S' },
          { label: 'X',
            value: 'X' },
        ];
      }

      if (this.typeForm.type === 'Office') {
        return [
          { label: 'A',
            value: 'A' },
          { label: 'B',
            value: 'B' },
          { label: 'C',
            value: 'C' },
        ];
      }

      // if (this.typeForm.type === 'Parking') {
      return [
        { label: 'P',
          value: 'P' },
        { label: 'PL',
          value: 'PL' },
        { label: 'PT',
          value: 'PT' },
        { label: 'PR',
          value: 'PR' },
      ];
    },
    tagsBasedOnType() {
      if (this.typeForm.type === 'Office') {
        return officeTags;
      }

      if (this.typeForm.type === 'Parking') {
        return parkingTags;
      }

      return unitTags;
    },
  },
  mounted() {
    if (this.unit) {
      if (this.unit._id) { this.active = 1; }

      this.form = this.unit;
      this.typeForm = { type: this.unit.type };
      this.tags = this.unit.tags;
      this.selectedTags = this.unit.tags.map(tag => tag.value).filter(tag => tag !== 'No Photos');
      this.images = this.unit.images;
    }
  },
  data() {
    const width = window.innerWidth / 2;
    const height = window.innerHeight / 2;
    return {
      unitTags,
      selectedTags: [],
      typeForm: {
        type: 'Warehouse',
      },
      form: {
        length: '',
        width: '',
        sides: 4,
        computedSize: null,
        size: '',
        tierQuality: '',
      },
      tags: [],
      tagInput: '',
      active: 0,
      rules: {},
      images: [],
      configKonva: {
        width,
        height,
      },
    };
  },
  methods: {
    resetComputedSizeAndTier() {
      this.form.size = '';
      this.form.tierQuality = '';
      this.form.computedSize = '';
      if (this.typeForm.type === 'Parking') {
        this.form.computedSize = 100;
      }
    },
    prepareTags() {
      this.tags = this.selectedTags.map(tag => ({ value: tag }));
    },
    setSizeMatrix(size) {
      this.form.size = setMatrixValueBasedOnTheSize(size, this.typeForm.type);
    },
    addTag(value) {
      const values = this.tags.map(item => item.value);
      if (!values.includes(value)) {
        this.tags.push({ value });
      }
      this.tagInput = '';
    },
    addUnit() {
      const unit = {
        ...this.form,
        ...this.typeForm,
        tags: [...this.tags],
        images: [...this.images],
      };
      this.$emit('unit-added', unit);
      this.clearUnitData();
    },
    clearUnitData() {
      this.selectedTags = [];
      this.typeForm = {
        type: 'Warehouse',
      };

      this.form = {
        length: '',
        width: '',
        sides: 4,
        computedSize: null,
        size: '',
        tierQuality: 'A',
      };
      this.tags = [];
      this.tagInput = '';
      this.active = 0;
      this.images = [];
    },
    addImageToUnit(url) {
      this.images.push({ url, createdBy: this.$keycloak.tokenParsed.email });
    },
    removeImage(url) {
      const updatedImages = this.images.map(document => document.url !== url);
      this.images = updatedImages;
    },
    next() {
      switch (this.active) {
        case 0:
          if (this.typeForm.type === 'Parking') {
            this.form.length = 10;
            this.form.width = 10;
            this.form.computedSize = 100;
            this.form.height = 10;
            this.setSizeMatrix(100);
          }
          this.active += 1;
          break;
        case 1:
          return this.$refs.details.validate((valid) => {
            if (valid) {
              this.active += 1;
            }
          });
        case 2:
          this.active += 1;
          break;
        case 3:
          this.active += 1;
          break;
        case 4:
          this.active += 1;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.tags {
  margin-top: 8px;
  height: 314px ;
}
.tag {
  margin-right: 8px;
}

 .upload-card{
  overflow:scroll;
  height: 300px ;
 }
</style>



// WEBPACK FOOTER //
// src/components/NewSiteUnitType.vue